import React from 'react';

import { useDragDropManager } from 'react-dnd';
import Overlay from 'ui/utils/Overlay';

import './DragLayer.scss';
import ItemImage from './ItemImage';

export default function DragLayer() {
  const dragDropManager = useDragDropManager();
  const monitor = dragDropManager.getMonitor();
  const [item, setItem] = React.useState();

  const updateState = React.useCallback(() => setItem(monitor.getItem()), [monitor]);
  React.useEffect(() => monitor.subscribeToStateChange(updateState), [monitor, updateState]);

  const previewRef = React.useRef();
  const updateOffset = React.useCallback(() => {
    if (previewRef.current) {
      const offset = monitor.getClientOffset();
      if (offset) {
        previewRef.current.style.left = `${offset.x}px`;
        previewRef.current.style.top = `${offset.y}px`;
        previewRef.current.style.visibility = "";
      } else {
        previewRef.current.style.visibility = "hidden";
      }
    }
  }, [monitor]);
  React.useEffect(() => monitor.subscribeToOffsetChange(updateOffset), [monitor, updateOffset]);

  if (!item) return null;

  if (item.type === "ITEM") {
    return (
      <Overlay>
        <ItemImage className="d2p-DragPreview" id={item.id} ref={previewRef}/>
      </Overlay>
    );
  }

  return null;
}
